import type {KeyTextField, LinkField} from '@prismicio/client'
import {useLinkResolver} from 'prismicio'
import type {SurveySectionSliceDefaultPrimaryResultsItem} from 'prismicio-types'
import {ButtonV2} from 'src/common/ButtonV2'

export const ResultsStep = ({
  funnelScore,
  demoLink,
  demoLabel,
  continueWithoutDemoHandler,
  continueWithoutDemoLabel,
  results,
  pageUid,
}: {
  funnelScore: number
  demoLink: LinkField
  demoLabel: KeyTextField
  continueWithoutDemoHandler: VoidFunction
  continueWithoutDemoLabel: KeyTextField
  results: SurveySectionSliceDefaultPrimaryResultsItem[]
  pageUid: string
}) => {
  const {linkResolver} = useLinkResolver()

  const content = getResult(funnelScore, results)

  return (
    <div className="flex flex-col items-center justify-center gap-8">
      <div className="flex flex-col gap-6">
        <h3 className="text-h3 font-bold text-moss-black">{content?.title}</h3>
        <p className="text-body text-moss-black">{content?.content}</p>
      </div>
      <div className="flex flex-col gap-3">
        <ButtonV2
          variant="primary"
          href={linkResolver(demoLink)}
          trackingData={{
            mktgId: 'book-demo-button',
            location: 'survey-section-results',
            dataType: content?.type || '',
            pageName: pageUid,
            label: demoLabel || 'Book a demo',
          }}
        >
          {demoLabel}
        </ButtonV2>
        <ButtonV2
          variant="secondary"
          onClick={continueWithoutDemoHandler}
          trackingData={{
            mktgId: 'continue-button',
            location: 'survey-section-results',
            dataType: content?.type || '',
            pageName: pageUid,
            label: continueWithoutDemoLabel || 'Continue without demo',
          }}
        >
          {continueWithoutDemoLabel}
        </ButtonV2>
      </div>
    </div>
  )
}

export const getResult = (score: number, options: SurveySectionSliceDefaultPrimaryResultsItem[]) => {
  let category

  if (score >= 18) {
    category = 'high_priority'
  } else if (score >= 10) {
    category = 'medium_priority'
  } else {
    category = 'low_priority'
  }

  return options.find((result) => result.type?.replace(' ', '_').toLowerCase() === category)
}
